import React from "react";
// ── Skeleton card that mimics one IAQ chart ──────────────────────────────
const ChartSkeleton = ({ height = 260 }: { height?: number }) => (
  <div className="kpi-card-iaq skeleton-card" style={{ height }}>
    {/* Title bar */}
    <div className="sk-title" />

    {/* Y-axis ticks */}
    <div className="sk-y-axis">
      {[0,1,2,3,4].map(i => <div key={i} className="sk-tick" style={{ "--i": i } as any} />)}
    </div>

    {/* Chart body with animated wave */}
    <div className="sk-chart-body">
      <svg className="sk-wave-svg" viewBox="0 0 400 100" preserveAspectRatio="none">
        <defs>
          <linearGradient id="skWaveGrad" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="rgba(0,229,255,0.18)" />
            <stop offset="100%" stopColor="rgba(0,229,255,0.03)" />
          </linearGradient>
          <linearGradient id="skShimmer" x1="0" y1="0" x2="1" y2="0">
            <stop offset="0%"   stopColor="transparent" />
            <stop offset="50%"  stopColor="rgba(0,229,255,0.10)" />
            <stop offset="100%" stopColor="transparent" />
            <animateTransform attributeName="gradientTransform" type="translate"
              from="-1 0" to="2 0" dur="1.8s" repeatCount="indefinite" />
          </linearGradient>
        </defs>
        {/* Horizontal grid lines */}
        {[20,40,60,80].map(y => (
          <line key={y} x1="0" y1={y} x2="400" y2={y}
            stroke="rgba(255,255,255,0.08)" strokeWidth="0.5" />
        ))}
        {/* Filled area under wave */}
        <path
          d="M0,70 C40,60 80,30 120,45 C160,60 200,20 240,35 C280,50 320,25 360,40 L400,38 L400,100 L0,100 Z"
          fill="url(#skWaveGrad)"
        />
        {/* Wave line */}
        <path
          d="M0,70 C40,60 80,30 120,45 C160,60 200,20 240,35 C280,50 320,25 360,40 L400,38"
          fill="none" stroke="rgba(0,229,255,0.35)" strokeWidth="1.5"
        />
        {/* Shimmer overlay */}
        <rect x="0" y="0" width="400" height="100" fill="url(#skShimmer)" />
      </svg>
    </div>

    {/* X-axis ticks */}
    <div className="sk-x-axis">
      {[0,1,2,3,4].map(i => <div key={i} className="sk-tick-x" style={{ "--i": i } as any} />)}
    </div>
  </div>
);

export default ChartSkeleton;